import { Injectable } from '@angular/core';
import { MeCompanyService } from './me-company.service';

@Injectable({ providedIn: 'root' })
export class CompanyContextService {

    sunatAmazoniaLaw = false;
    private loaded = false;

    constructor(private meCompanyService: MeCompanyService) {}

    load(): void {
        if (this.loaded) return;
        this.loaded = true;
        this.meCompanyService.get().subscribe({
            next: res => { this.sunatAmazoniaLaw = res.data?.sunatAmazoniaLaw ?? false; },
            error: () => {}
        });
    }
}
